module.exports = __webpack_public_path__ + "img/promo-3.e2fb7f28.png";